import { render, staticRenderFns } from "./otherTeamDetail.vue?vue&type=template&id=c2d1066e&"
import script from "./otherTeamDetail.vue?vue&type=script&lang=js&"
export * from "./otherTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherTeamDetail.vue?vue&type=style&index=0&id=c2d1066e&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports